import PropTypes from 'prop-types';
import { forwardRef, useEffect, useLayoutEffect, useImperativeHandle, useRef } from 'react';
import Phaser from 'phaser';
import { WheelScene } from './WheelScene';

//not used just for reference
const config = {
	type: Phaser.AUTO,
	width: 768,
	height: 768,
	parent: 'game-container',
	backgroundColor: '#028af8',
	transparent: true,
	// scene: [
	// 	// Preloader,
	// 	Wheel,
	// 	// Boot,
	// 	// MainMenu,
	// 	// Game,
	// 	// GameOver
	// ]
};

export const PhaserGame = forwardRef(function PhaserGame({sceneClass, sceneKey, sceneData }, ref) {
	const eventBus = useRef(new Phaser.Events.EventEmitter());
	const game = useRef();
	const containerRef = useRef();
	const canvasRef = useRef();

	useImperativeHandle(ref, () => {
		return {
			eventBus: eventBus.current,
			execute(data) {
				game.current?.scene.getScene(sceneKey).execute(data)
			},
		};
	}, []);

	// Create the game inside a useLayoutEffect hook to avoid the game being created outside the DOM
	useLayoutEffect(() => {

		if (game.current === undefined) {
			game.current = new Phaser.Game({
				type: Phaser.AUTO,
				width: sceneData.width || 768,
				height: sceneData.height || 768,
				mode: Phaser.Scale.NONE,
				parent: containerRef.current,
				canvasStyle: "width: 100%; max-height: 70vh;",
				// canvas: canvasRef.current,
				// backgroundColor: '#028af8',
				transparent: true,
				// scene: WheelScene
			})
			// console.log("game.current", game.current)
			game.current.scene.add(sceneKey, sceneClass)
			game.current.scene.start(sceneKey, {...sceneData, eventBus: eventBus.current})
		}

		return () => {

			if (game.current) {
				game.current.destroy(true);
				game.current = undefined;
			}

		}
	}, []);

	// useEffect(() => {

	// 	EventBus.on('current-scene-ready', (currentScene) => {

	// 		// if (currentActiveScene instanceof Function) {
	// 		// 	currentActiveScene(currentScene);
	// 		// }
	// 		ref.current.scene = currentScene;

	// 	});

	// 	return () => {
	// 		EventBus.removeListener('current-scene-ready');
	// 	}

	// }, [ref])

	return (
		<div ref={containerRef} className="phaser-container w-full">
			{/* <canvas ref={canvasRef} className="phaser-canvas w-full"></canvas> */}
		</div>
	);

});

// // Props definitions
// PhaserGame.propTypes = {
// 	currentActiveScene: PropTypes.func
// }
